<template>
  <div class="hello">

    <div v-if="success">
      <h1 class="is-size-1 has-text-centered">{{ $t('This form has been sent successfully.') }} <i>¡Gracias! </i>
      </h1>
    </div>
    <div  v-else >

    <div class="p-b-20 has-text-weight-bold">{{ $t('First, please indicate how you want your event to be published on the website') }}</div>
    <div>


      <div class="field">
            <input class="is-checkradio" id="exampleRtlRadio1" type="radio" name="exampleRtlRadio1" value="online" v-model="online">
            <label for="exampleRtlRadio1">{{ $t('My event is online, I want it published on the map but I do NOT want my address published') }}</label>
        </div>
        <div class="field">
            <input class="is-checkradio" id="exampleRtlRadio2" type="radio" name="exampleRtlRadio2" value="offline" v-model="online">
            <label for="exampleRtlRadio2">{{ $t('I want my event and address to appear on the map') }}</label>
        </div>

    </div>

    <form v-if="online" @submit.prevent="submit" novalidate>
      <div class="field">
        <label class="label">{{ $t('Name of event organiser') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="nameOfEventOrganiser" class="input" type="text">
        </div>
        <div class="has-text-error-message" v-if="v$.nameOfEventOrganiser.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Email of event organiser') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="emailOfEventOrganiser" type="email" class="input">
          <div class="has-text-error-message" v-if="v$.emailOfEventOrganiser.$error">{{ $t('email') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Name of event') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="nameOfEvent" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.nameOfEvent.$error">{{ $t('nec') }}</div>
      </div>

      <label class="label">{{ $t('Date and time') }}</label>
      <div class="has-text-error-message" v-if="v$.datesAndTimes.$error">{{ $t('nec') }}</div>
      <div class="p-b-30" style="border-bottom: 1px  #ccc dotted" v-for="(date,i) in datesAndTimes" :key="i">
        <br/>
        <div class="field">
          <input class="is-checkradio" :id="`dateCheckbox_${i}`" type="checkbox" :name="`dateCheckbox_${i}`" v-model="date.checked">
          <label style="font-weight: bold" :for="`dateCheckbox_${i}`">{{ date.dayStr }}</label>
        </div>
        <div class="columns p-t-0">
          <div class="column">
            <div class="field">
              <label style="font-weight: normal" class="label  m-t-0">{{ $t('Starts') }}</label>
              <div class="control">
<!--                <input v-model="date.timeFrom" type="time" class="input">-->
                <select @change="date.checked=true"  style="width: 47%" v-model="date.timeFromHours">
                  <option value="">H</option>
                  <option v-for="t in hours" :value="t" :key="t" >{{t}}</option>
                </select>
                <span style="width: 6%" class="inline-block">:</span>
                 <select @change="date.checked=true" style="width: 47%" v-model="date.timeFromMin">
                  <option v-for="t in mins" :value="t" :key="t" >{{t}}</option>
                </select>

              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label style="font-weight: normal" class="label m-t-0">{{ $t('Ends') }}</label>
              <div class="control">
<!--                <input v-model="date.timeTo" type="time" class="input" />-->

                <select @change="date.checked=true" style="width: 47%" v-model="date.timeToHours">
                  <option v-for="t in hours" :value="t" :key="t" >{{t}}</option>
                </select>
                <span style="width: 6%" class="inline-block">:</span>
                 <select @change="date.checked=true" style="width: 47%" v-model="date.timeToMin">
                  <option v-for="t in mins" :value="t" :key="t" >{{t}}</option>
                </select>


              </div>
            </div>
          </div>
        </div>


      </div>

      <div class="field">
        <label class="label">{{ $t('Name of venue') }}</label>
        <div class="control">
          <input v-model="nameOfVenue" type="text" class="input" />
        </div>
      </div>

      <label class="label">{{ $t('Event Type') }} <span class="required">*</span></label>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox" type="checkbox" name="exampleRtlCheckbox" v-model="eventTypes.mediaAndTrade">
        <label for="exampleRtlCheckbox">{{ $t('Media and trade') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox1" type="checkbox" name="exampleRtlCheckbox1" v-model="eventTypes.onlineEvent">
        <label for="exampleRtlCheckbox1">{{ $t('Online event') }}</label>
      </div>
<!--      <div class="field">-->
<!--        <input class="is-checkradio" id="exampleRtlCheckbox2" type="checkbox" name="exampleRtlCheckbox2" v-model="eventTypes.sherryPairingMenu">-->
<!--        <label for="exampleRtlCheckbox2">{{ $t('Sherry Pairing Menu') }}</label>-->
<!--      </div>-->

      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox3" type="checkbox" name="exampleRtlCheckbox3" v-model="eventTypes.sherryTasting">
        <label for="exampleRtlCheckbox3">{{ $t('Sherry Tasting') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox4" type="checkbox" name="exampleRtlCheckbox4" v-model="eventTypes.sherryCocktails">
        <label for="exampleRtlCheckbox4">{{ $t('Sherry Cocktails') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox5" type="checkbox" name="exampleRtlCheckbox5" v-model="eventTypes.sherryTourism">
        <label for="exampleRtlCheckbox5">{{ $t('Sherry Tourism') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox6" type="checkbox" name="exampleRtlCheckbox6" v-model="eventTypes.sherryRetail">
        <label for="exampleRtlCheckbox6">{{ $t('Sherry Retail Promotion') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox7" type="checkbox" name="exampleRtlCheckbox7" v-model="eventTypes.sherryPairing">
        <label for="exampleRtlCheckbox7">{{ $t('Sherry Pairing') }}</label>
      </div>
      <div class="has-text-error-message" v-if="v$.eventTypes.$error">{{ $t('atLeastOne') }}</div>

      <label class="label">{{ $t('Address') }}</label>
      <div class="field">
        <label class="label">{{ $t('Country') }} <span class="required">*</span></label>
        <div class="select is-fullwidth">
          <select v-model="country">
            <option v-for="country in countries" :value="country.value" :key="country.label">
              {{ country.label }}
            </option>
          </select>
          <div class="has-text-error-message" v-if="v$.country.$error">{{ $t('nec') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Address 1') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="address" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.address.$error">{{ $t('nec') }}</div>
      </div>

      <div class="fields ">
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">{{ $t('Postal code') }} <span class="required">*</span></label>
              <div class="control">
                <input v-model="postalCode" type="text" class="input">
              </div>
              <div class="has-text-error-message" v-if="v$.postalCode.$error">{{ $t('nec') }}</div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">{{ $t('City') }} <span class="required">*</span></label>
              <div class="control">
                <input v-model="city" type="text" class="input">
              </div>
              <div class="has-text-error-message" v-if="v$.city.$error">{{ $t('nec') }}</div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">{{ $t('Province') }} <span class="required">*</span></label>
              <div class="control">
                <input v-model="province" type="text" class="input">
              </div>
              <div class="has-text-error-message" v-if="v$.province.$error">{{ $t('nec') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Event information') }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="eventInfo" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.eventInfo.$error">{{ $t('nec') }}</div>
      </div>

      <label class="label">{{ $t('Event Image: please upload an image of your venue') }} <span class="required">*</span></label>
      <div class="uploader uploader1">
        <file-upload v-show="files.length == 0"
                     input-id="file1"
                     class="has-text-centered "
                     extensions="jpg,jpeg,png"
                     accept="image/png,image/jpeg"
                     post-action="/api/upload-image/"
                     ref="file1"
                     v-model="files"
                     :headers="{'X-CSRFTOKEN': csrf}"
                     :drop="'.uploader1'"
                     :size="1024 * 1024 *4"
                     @input-filter="inputFilter"
                     @input-file="inputFile"
        >
          <div>
            <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB') }}.
              <br>
              {{ $t('Allowed file types: gif jpg jpeg') }}.
            </div>
          </div>

        </file-upload>
        <div v-if="files.length > 0">
          <div class="columns is-gapless">
            <div class="column is-4">
              <img
                  :src="files.length ? files[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                  class="upload-photo"/>
            </div>
            <div class="column">
              <div>
                <p class="pb-5">{{ files[0].name }}</p>

                <button
                    style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                    class="button is-uppercase has-text-weight-bold has-text-white" @click="files=[]"
                    type="button">X
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="has-text-error-message" v-if="v$.f1.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Contact email for event') }}</label>
        <div class="control">
          <input v-model="contactEmailForEvent" type="email" class="input">
          <div class="has-text-error-message" v-if="v$.contactEmailForEvent.$error">{{ $t('email') }}</div>

        </div>
      </div>






      <div class="field">
        <label class="label">{{ $t('Venue Telephone') }}</label>
        <div class="control">
          <input v-model="venueTelephone" type="text" class="input">
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Website') }}</label>
        <div class="control">
          <input v-model="website" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.website.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Online Registration') }}</label>
        <div class="control">
          <input v-model="onlineReg" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.onlineReg.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Reservations required') }} <span class="required">*</span></label>
        <div class="select is-fullwidth">
          <select v-model="reservations">
            <option value="">- None -</option>
            <option value="0">No</option>
            <option value="1">Yes</option>
          </select>
          <div class="has-text-error-message" v-if="v$.reservations.$error">{{ $t('nec') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Age range') }} <span class="required">*</span></label>
        <div class="select is-fullwidth">
          <select v-model="ageRange">
            <option value="">- {{$t('Select')}} -</option>
            <option value="18 and over">18 and over</option>
            <option value="21 and over">21 and over</option>
            <option value="Unrestricted">Unrestricted</option>
          </select>
          <div class="has-text-error-message" v-if="v$.ageRange.$error">{{ $t('nec') }}</div>
        </div>
      </div>

      <label class="label">{{ $t('Please subscribe me to your newsletter') }}</label>
      <div class="field">
        <input v-model="newsletter" class="is-checkradio" id="newsletterCheckbox" type="checkbox"
               name="newsletterCheckbox"
               checked="checked">
        <label for="newsletterCheckbox">{{ $t('I accept to recieve promotions, offers and commercial communications') }}</label>
      </div>

<!--      <div v-if="lang == 'en'">-->
<!--        <label class="label">Tick here if you are a UK Independent Wine Store and agree to the <a target="_blank"-->
<!--                                                                                                  href="https://www.sherry.wine/sherryweek/about/uk-independent-wine-stores-win-a-vip-trip-to-jerez-in-2025">terms-->
<!--          and conditions</a> for entering the competition to win a VIP trip to Jerez.</label>-->
<!--        <div class="field">-->
<!--          <input v-model="ukIndependentWineStore" class="is-checkradio" id="ukCheckbox" type="checkbox"-->
<!--                 name="ukCheckbox"-->
<!--          >-->
<!--          <label for="ukCheckbox">{{ $t('Yes') }}</label>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div >-->
<!--        <label  class="label">-->
<!--          <span v-if="lang == 'en'">-->
<!--            I have read the <a href="https://www.sherry.wine/sherryweek/about/register-event-win-online-masterclass-cesar-saldana" target="_blank">terms and conditions</a> and wish to enter the chance to win an online Masterclass with Cesar Saldana.-->
<!--          </span>-->
<!--          <span v-else>-->
<!--            He leído los <a href="https://www.sherry.wine/es/sherryweek/sobre/registra-evento-gana-masterclass-online-cesar-saldana" target="_blank">términos y condiciones</a> y deseo participar en el sorteo para ganar una masterclass online con César Saldaña.-->
<!--          </span>-->
<!--        </label>-->
<!--        <div class="field">-->
<!--          <input v-model="competitionMasterclass" class="is-checkradio" id="competitionMasterclass" type="checkbox"-->
<!--                 name="competitionMasterclass"-->
<!--          >-->
<!--          <label for="competitionMasterclass">{{ $t('Yes') }}</label>-->
<!--        </div>-->
<!--      </div>-->

      <div class="field">
        <label class="label">{{ $t('Url for Facebook') }}</label>
        <div class="control">
          <input v-model="facebook" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.facebook.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Instagram url') }}</label>
        <div class="control">
          <input v-model="instagram" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.instagram.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Handle for twitter') }}</label>
        <div class="control">
          <input v-model="twitter" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.twitter.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <label class="label">{{ $t('Event Poster') }}</label>

      <div class="uploader uploader2">

        <file-upload v-show="files2.length == 0"
                     input-id="file2"
                     class="has-text-centered "
                     extensions="jpg,jpeg,png"
                     accept="image/png,image/jpeg"
                     post-action="/api/upload-image/"
                     ref="file2"
                     v-model="files2"
                     :headers="{'X-CSRFTOKEN': csrf}"
                     :drop="'.uploader2'"
                     :size="1024 * 1024 *4"
                     @input-filter="inputFilter"
                     @input-file="inputFile2"
        >
          <div>
            <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB') }}.
              <br>
              {{ $t('Allowed file types: gif jpg jpeg') }}.
            </div>
          </div>

        </file-upload>
        <div v-if="files2.length > 0">
          <div class="columns is-gapless">
            <div class="column is-4">
              <img
                  :src="files2.length ? files2[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                  class="upload-photo"/>
            </div>
            <div class="column">
              <div>
                <p class="pb-5">{{ files2[0].name }}</p>

                <button
                    style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                    class="button is-uppercase has-text-weight-bold has-text-white" @click="files2=[]"
                    type="button">X
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br/>



<!--      <div  class="field" >-->
<!--        <input v-model="competition" class="is-checkradio" id="competition" type="checkbox" name="competition"-->
<!--               checked="checked">-->
<!--        <label  for="competition">{{ $t('I wish to participate in the competition to win the most innovative event and') }} &nbsp;  <a target="_blank" style="color: #D37700; text-decoration: underline" :href="winlink">{{ $t('agree to the terms and conditions.')}}</a> </label>-->
<!--      </div>-->



      <div class="field" >
        <input v-model="termsAndConditions" class="is-checkradio" id="termsAndConditionsCheckbox" type="checkbox" name="termsAndConditionsCheckbox"
               checked="checked">
        <label  for="termsAndConditionsCheckbox">{{ $t('I accept conditions laid out in the') }} &nbsp; <a target="_blank" style="color: #D37700; text-decoration: underline"
                                                                                                       href="https://www.sherry.wine/es/privacy">{{ $t('Legal Notice and Privacy Policy') }}</a>
          <span class="required"> *</span></label>
        <div class="has-text-error-message" v-if="v$.termsAndConditions.$error">{{ $t('nec') }}</div>
      </div>



      <div class="pt-5">
        <button style="background: #D37700; font-size: 14px; padding: 20px 40px;border: none"
                type="submit" class="button is-uppercase has-text-white has-text-weight-bold ">{{ $t('Send Event') }}
        </button>
      </div>
    </form>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {required, email, integer, url, helpers, requiredIf} from '@vuelidate/validators';
import VueUploadComponent from 'vue-upload-component';
import axios from "axios";

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

const phone = helpers.regex(/^\+34[0-9 ]{5,10}$/);
//const urlx = helpers.regex(/^http.*$/);

const time = helpers.regex(/^(0?[1-9]|1[012]):[0-5][0-9]$/);

import FileComponent from "./FileComponent.vue";

const hasddress = (value, siblings) => {
  //console.log("siblings");
  //console.log(siblings);
  return true && value;
};

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export default {

  setup() {
    return {v$: useVuelidate()};
  },
  name: 'Sherryweek',
  components: {
    'file-upload': VueUploadComponent,
    'file-component': FileComponent,
  },
  props: {
    csrf: String,
    lang: String,
    startdate: String,
    enddate: String,
    waglocale: String
  },
  data() {
    return {

      mins:['00','30'],
        hours:['00','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],


      legallink:null,
      winlink:null,
      success: false,
      nec: "Este campo es necesario",
      mail: "Este campo tiene que ser un email",
      url: "Este campo tiene que ser un url",
      tel: "Este campo tiene que ser teléfono",
      cpe: "Este campo tiene que un código postal",
      online:null,
      nameOfEventOrganiser: '',
      emailOfEventOrganiser: '',
      nameOfEvent: '',
      datesAndTimes: [],
      nameOfVenue: '',
      // event type
      eventTypes: {
        mediaAndTrade: false,
        onlineEvent: false,
        sherryPairingMenu: false,
        sherryTasting: false,
        sherryCocktails: false,
        sherryTourism: false,
        sherryRetail: false,
        sherryPairing: false,
      },
      country: null,
      address: '',
      postalCode: '',
      city: '',
      province: '',
      eventInfo: '',

      files: [],
      files2: [],
      f1: null,
      f2: null,
      contactEmailForEvent: '',
      venueTelephone: '',
      website: '',
      onlineReg: '',
      reservations: '',
      ageRange: '',
      newsletter: false,
      instagram: '',
      facebook: '',
      twitter: '',
      termsAndConditions: null,
      competition:null,
      ukIndependentWineStore:false,
      competitionMasterclass:false
    };
  },
  validations() {
    function termsAgreed() {
      return this.termsAndConditions;
    }

    function atLeastOneEvent() {
      for (const item in this.eventTypes) {
        if (this.eventTypes[item])
          return true;
      }
      return false;
    }

    function atLeastOneDate() {
      for (const item of this.datesAndTimes) {
        if (item.checked)
          return true;
      }
      return false;
    }

    return {
      nameOfEventOrganiser: {required},
      emailOfEventOrganiser: {required, email},
      contactEmailForEvent: {email},
      nameOfEvent: {required},
      datesAndTimes: {atLeastOneDate},
      eventTypes: {atLeastOneEvent},
      country: {required},
      address: {required},
      postalCode: {required},
      city: {required},
      province: {required},
      eventInfo: {required},
      f1: {required},
      website: {url},
      onlineReg: {url},
      reservations: {required},
      ageRange: {required},
      facebook: {url},
      instagram: {url},
      twitter: {url},
      termsAndConditions: {termsAgreed},

    };
  },
  methods: {
    doSuccess() {
      if(this.lang == 'en'){
        window.location.href = "https://www.sherry.wine/sherryweek/success";
      }
      else{
        window.location.href = "https://www.sherry.wine/"+this.lang+"/sherryweek/success";
      }
    },

    async submit() {
      const result = await this.v$.$validate();
      if (!result) {
        // notify user form is invalid
        //console.log("in valid");
        this.scrollToClass('has-text-error-message');
        return;
      }

      this.datesAndTimes.forEach((o, i) => {
        this.datesAndTimes[i].timeFrom = `${o.timeFromHours}:${o.timeFromMin}`
        this.datesAndTimes[i].timeTo =`${o.timeToHours}:${o.timeToMin}`
      })

      const formData = {
        f1: this.f1,
        f2: this.f2,

        nameOfEventOrganiser: this.nameOfEventOrganiser,
        emailOfEventOrganiser: this.emailOfEventOrganiser,
        nameOfEvent: this.nameOfEvent,
        datesAndTimes: this.datesAndTimes,
        nameOfVenue: this.nameOfVenue,
        // event type
        eventTypes: this.eventTypes,
        country: this.country,
        address: this.address,
        postalCode: this.postalCode,
        city: this.city,
        province: this.province,
        eventInfo: this.eventInfo,
        contactEmailForEvent: this.contactEmailForEvent,
        venueTelephone: this.venueTelephone,
        website: this.website,
        onlineReg: this.onlineReg,
        reservations: this.reservations,
        ageRange: this.ageRange,
        newsletter: this.newsletter,
        instagram: this.instagram,
        facebook: this.facebook,
        twitter: this.twitter,
        termsAndConditions: this.termsAndConditions,
        waglocale: this.waglocale,
        competition: this.competition,
        offline:this.online=='online'?false:true,
        userlang: this.lang,
        ukIndependentWineStore: this.ukIndependentWineStore,
        competitionMasterclass: this.competitionMasterclass
      };
      //console.log(formData);
      axios.post("/api/sherryweek/", formData)
          .then((res) => {
            console.log(res);
            this.doSuccess();
            // this.success = true;
          })
          .catch((err) => {
            alert("There has been an error, please contact support. Ha habido un error, contacta con soporte");
          });
    },

    scrollToClass(className) {
      const el = this.$el.getElementsByClassName('has-text-error-message')[0];
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
      }
    },

    async inputFile(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file1.active) {
          this.$refs.file1.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },
    async inputFile2(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file2.active) {
          this.$refs.file2.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        if (!newFile.name.match((/(.jpg|.png|.jpeg|.JPG|.JPEG|.PNG)$/))) {
          alert(this.$t("The image must be png or jpg"));
          return prevent();
        }
      }


      if (newFile.size > 1024 * 1024 * 4 || newFile.size < 1024 * 1024 * 0.25) {
        alert(this.$t("The image must be greater than 250kb and less than 2mb"));
        return prevent();
      }


      // const w = await this.checkWidth(URL.createObjectURL(newFile.file))
      // if(w < 2000){
      //   console.log('in',w)
      //     this.files = []
      //     newFile=null
      //     return prevent();
      // }
      // console.log('out',w)



      if (newFile && newFile.error === "" && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        let URL = (window.URL || window.webkitURL);
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }


        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }

      }
    },
    async checkWidth(blob){
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = blob;
          img.onload = () => resolve(img.width)
          img.onerror = reject
        })
    },
    buildDates() {
      const start = new Date(this.startdate+"T00:00:00.000Z");
      const end = new Date(this.enddate+"T00:00:00.000Z");
      let loop = new Date(start);

      const l =this.lang == 'jp'?'ja':this.lang
      const d =this.lang == 'jp'?'short':'long'

      while (loop <= end) {
        this.datesAndTimes.push({
          checked: false,
          dayStr: loop.toLocaleDateString(l, { year: 'numeric', month: 'short', weekday: d, day: 'numeric', timeZone: 'UTC' }),
          day: new Date(loop),
          timeFrom: '00:00',
          timeTo: '00:00',

          timeFromHours: '00',
          timeFromMin: '00',
          timeToHours: '00',
          timeToMin: '00'

        });
        let newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
      }
    }
  },
  computed: {
    countries() {
      const list = countries.getNames('en', {select: 'official'});
      return Object.keys(list).map((key) => ({value: key, label: list[key]}));
    }
  },
  watch: {
    files: {
      handler: function (files, oldVal) {
        if (files.length > 0 && files[0].response && files[0].response.id) {
          this.f1 = files[0].response.id;
          //console.log("this.f1 = ", this.f1);
          return;
        }
        this.f1 = null;
        //console.log("this.f1 = ", this.f1);
      },
      deep: true
    },
    files2: {
      handler: function (files2, oldVal) {
        if (files2.length > 0 && files2[0].response && files2[0].response.id) {
          this.f2 = files2[0].response.id;
          return;
        }
        this.f2 = null;

      },
      deep: true
    }
  },
  mounted() {
    this.$i18n.locale = this.lang;
    this.buildDates();

    const links = {
      'en': 'https://www.sherry.wine/sherryweek/win-1000-worth-of-sherry',
      'es': 'https://www.sherry.wine/es/sherryweek/sobre/gana-1000-en-vinos-de-jerez',
      'jp': 'https://www.sherry.wine/jp/sherryweek/sobre/gana-1000-en-vinos-de-jerez',

    }

    this.winlink = links[this.lang]

    if(this.lang == 'en'){
      this.legallink = 'https://www.sherry.wine/legal'
    }
    else{
      this.legallink = 'https://www.sherry.wine/'+this.lang+'/legal'
    }

    const date = new Date();
    const offset = date.getTimezoneOffset();
    console.log("offset");
    console.log(offset);    // -300

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #d37700;
}

.is-checkradio[type=checkbox] + label::after, .is-checkradio[type=checkbox] + label:after {
  color: #292624;
  border-color: #292624;

}

.is-checkradio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before {
  background: #FBF5EF;

}


label.label {
  margin-top: 30px;
}

dio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before, .is-checkradio[type=radio] + label::before, .is-checkradio[type=radio] + label:before {
  border: 1px solid #2b1b0d !important;;
}

.is-checkradio[type=checkbox]:hover:not([disabled]) + label::before, .is-checkradio[type=checkbox]:hover:not([disabled]) + label:before, .is-checkradio[type=radio]:hover:not([disabled]) + label::before, .is-checkradio[type=radio]:hover:not([disabled]) + label:before {
  border: 1px solid #ccc !important;;

}

.uploader {
  padding: 30px;
  background: #FBF5EF;
  border: 1px dashed #C3B193;
  border-radius: 10px;
  width: 100%;
  display: block;

}

.has-text-error-message {
  background: darkred;
  color: white !important;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: 600;
  margin-top: 3px;
  display: block;
}

.upload-photo {
  width: 90%;
  height: auto;
  display: block;

}

</style>